import React from 'react';
import ReactSelect from "react-select";
import { useHistory } from "react-router-dom";

// Single source of truth for the "Select Insurance" quote dropdown used on the
// homepage hero and the About page. Each option points at its quote FORM.
// Keep these targets in sync with the actual routes in Routes.js.
export const insuranceOptions = [
    { label: "Auto Insurance", value: "/auto-insurance-form" },
    { label: "Homeowners Insurance", value: "/home-owner-insurance-form" },
    { label: "Commercial Auto Insurance", value: "/commercial-auto-insurance-form" },
    { label: "Trucking Insurance", value: "/trucking-insurance-quote" },
    { label: "Business Insurance", value: "/business-insurance-quote" },
    { label: "Workers Compensation", value: "/workers-compensation-form" },
    { label: "Earthquake Insurance", value: "/earthquake-insurance-quote" },
];

// Modern, clean styling: white rounded control with a soft shadow + green focus
// ring, no harsh divider, and a polished dropdown menu. Dark text + portal menu
// keep options readable even inside a hero that sets color:#fff (About page).
const GREEN = "#90CF36";
const styles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: "58px",
        height: "58px",
        backgroundColor: "#fff",
        border: state.isFocused ? `1px solid ${GREEN}` : "1px solid #d6dbe3",
        borderRadius: "10px",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(144,207,54,0.25)" : "0 2px 10px rgba(0,0,0,0.06)",
        paddingLeft: "6px",
        cursor: "pointer",
        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
        ":hover": { borderColor: GREEN },
    }),
    valueContainer: (provided) => ({ ...provided, height: "58px", padding: "2px 14px" }),
    placeholder: (provided) => ({ ...provided, color: "#6b7280", fontSize: "1.05rem" }),
    singleValue: (provided) => ({ ...provided, color: "#1a1a1a", fontSize: "1.05rem" }),
    input: (provided) => ({ ...provided, color: "#1a1a1a", fontSize: "16px" }),
    indicatorSeparator: () => ({ display: "none" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "58px" }),
    dropdownIndicator: (provided) => ({ ...provided, color: GREEN, paddingRight: "14px" }),
    menu: (provided) => ({ ...provided, zIndex: 9999, borderRadius: "10px", overflow: "hidden", boxShadow: "0 12px 30px rgba(0,0,0,0.14)", marginTop: "6px" }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "#fff" : "#333",
        backgroundColor: state.isSelected ? "#1b75bc" : state.isFocused ? "#eef5fb" : "#fff",
        fontSize: "1rem",
        padding: "12px 16px",
        cursor: "pointer",
    }),
    container: (provided) => ({ ...provided }),
};

export default function InsuranceQuoteSelect({ placeholder = "Select Insurance", buttonText = "Get a Free Quote" }) {
    const [insurance, setInsurance] = React.useState('');
    const [redirectLink, setRedirectLink] = React.useState('');
    const history = useHistory();

    const handleChange = (event) => {
        setInsurance(event);
        setRedirectLink(event.value);
    };

    const goToQuote = () => {
        if (redirectLink) history.push(redirectLink);
    };

    return (
        <div className="row g-0 justify-content-center align-items-center mx-auto" style={{ maxWidth: "600px" }}>
            <div className="col-sm-12 col-lg-7">
                <ReactSelect
                    onChange={handleChange}
                    styles={styles}
                    value={insurance}
                    placeholder={placeholder}
                    options={insuranceOptions}
                    isSearchable={false}
                    menuShouldScrollIntoView={false}
                    aria-label="Select an insurance type"
                />
            </div>
            <div className="col-sm-12 col-lg-5 mt-3 mt-lg-0 pl-lg-3">
                <button
                    onClick={goToQuote}
                    type="button"
                    className="btn btn-success btn-gm-green quote-cta-btn"
                    style={{ height: "58px", width: "100%", borderRadius: "10px", fontWeight: 700, fontSize: "1.05rem", letterSpacing: "0.3px", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px", lineHeight: 1, boxShadow: "none" }}>
                    {buttonText}
                </button>
            </div>
        </div>
    );
}
